import React from "react";
export const Links = [
  {
    to: "/institucion/admin/estudiantes",
    text: "Students",
    svg: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.03532 17.7398C6.6233 19.1462 8.71194 20 11 20C13.2881 20 15.3767 19.1462 16.9647 17.7398C16.672 16.6873 14.5694 16 11 16C7.43062 16 5.328 16.6873 5.03532 17.7398ZM3.6005 16.1246C4.72595 14.6381 7.3706 14 11 14C14.6294 14 17.274 14.6381 18.3995 16.1246C19.4086 14.6703 20 12.9042 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 12.9042 2.59138 14.6703 3.6005 16.1246ZM11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22ZM7 9C7 6.75576 8.5791 5 11 5C13.4142 5 15 6.92158 15 9.2C15 12.4796 13.2181 14 11 14C8.76086 14 7 12.4274 7 9ZM9 9C9 11.2693 9.81821 12 11 12C12.1777 12 13 11.2984 13 9.2C13 7.95042 12.2157 7 11 7C9.73374 7 9 7.81582 9 9Z"
          fill="#fff"
        />
      </svg>
    ),
  },
  {
    to: "/institucion/admin/instructores",
    text: "Instructors",
    svg: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.4 22V19.8H19.8V15.4H22V19.8C22 21.015 21.1046 22 20 22H15.4ZM6.6 22H2C0.89543 22 0 21.015 0 19.8V15.4H2.2V19.8H6.6V22ZM15.4 0H20C21.1046 0 22 0.984974 22 2.2V6.6H19.8V2.2H15.4V0ZM6.6 0V2.2H2.2V6.6H0V2.2C0 0.984974 0.89543 0 2 0H6.6Z"
          fill="#fff"
        />
        <path d="M10.9968 5.5C10.9968 8.43333 10.9978 10.2667 11 11C11 11.55 10.45 12.1 9.90001 12.1C9.53334 1" />
      </svg>
    ),
  },
  {
    to: "/institucion/admin/curso",
    text: "New course ",
    svg: (
      <svg
        width="20"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17 4H0V6H17V4ZM17 0H0V2H17V0ZM0 10H13V8H0V10ZM15 8V14L20 11L15 8Z"
          fill="#fff"
        />
      </svg>
    ),
  },
  {
    to: "/institucion/admin/cursos",
    text: "My courses",
    svg: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7778 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H17.7778C19 20 20 19 20 17.7778V2.22222C20 1 19 0 17.7778 0ZM6.66667 15.5556H4.44444V7.77778H6.66667V15.5556ZM11.1111 15.5556H8.88889V4.44444H11.1111V15.5556ZM15.5556 15.5556H13.3333V11.1111H15.5556V15.5556Z"
          fill="#fff"
        />
      </svg>
    ),
  },
  {
    to: "/institucion/admin/payment",
    text: "Payment",
    svg: (
      <svg
        width="22"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.821 10.426C15.108 10.9168 15.2727 11.489 15.2727 12.1C15.2727 13.9225 13.8075 15.4 12 15.4C10.1925 15.4 8.72727 13.9225 8.72727 12.1C8.72727 10.2775 10.1925 8.8 12 8.8C12.402 8.8 12.7872 8.8731 13.143 9.00684L16.0154 4.86919L17.8028 6.13081L14.821 10.426ZM4.7982 21.7794C1.8005 19.5084 0 15.9541 0 12.1C0 5.41735 5.37258 0 12 0C18.6274 0 24 5.41735 24 12.1C24 15.9541 22.1995 19.5084 19.2018 21.7794L18.9107 22H5.08933L4.7982 21.7794ZM18.1718 19.8C20.4578 17.9355 21.8182 15.1327 21.8182 12.1C21.8182 6.63238 17.4224 2.2 12 2.2C6.57757 2.2 2.18182 6.63238 2.18182 12.1C2.18182 15.1327 3.54216 17.9355 5.82822 19.8H18.1718ZM12 13.2C12.6025 13.2 13.0909 12.7075 13.0909 12.1C13.0909 11.4925 12.6025 11 12 11C11.3975 11 10.9091 11.4925 10.9091 12.1C10.9091 12.7075 11.3975 13.2 12 13.2Z"
          fill="#fff"
        />
      </svg>
    ),
  },
];
